import { cn } from './cn';

export interface SpinnerProps {
  className?: string;
  label?: string;
}

/**
 * Indicador de carregamento acessível.
 * - role="status" + aria-live="polite" no contêiner externo (definido pelo chamador).
 * - Animação desabilitada em prefers-reduced-motion via CSS global em index.css.
 */
export function Spinner({ className, label = 'Carregando' }: SpinnerProps) {
  return (
    <span
      className={cn(
        'inline-block h-6 w-6 animate-spin rounded-full border-2 border-brand-100 border-t-primary-700',
        className,
      )}
      aria-label={label}
      role="img"
    />
  );
}
